<template>

<core-modal-setting title="Devices" :value="valueText" placeholder="Always shown">
        
    <core-input-checklist 
        :options="options"
        v-model="internalValue"
    />

</core-modal-setting>

</template>

<script>

import mixSetting from 'core/mixin/modal/Setting'

export default {

    mixins: [mixSetting],

    props: ['view', 'field'],

    computed: {

        options: function() {

            var options = [
                {
                    value: 0,
                    text: 'All devices'
                },
                {
                    value: 1,
                    text: 'Large screens only'
                },
                {
                    value: 2,
                    text: 'Small screens only'
                }
            ]

            if(this.view.type === 1 && this.field.config.demotable) {

                options.push({
                    value: 3,
                    text: 'Demote on small screens',
                    description: 'Column on large screens but on small screens is show as a small metric below the game.'
                }) 

            }

            return options

        }

    }

}

</script>

<style scoped>

</style>